import { processesRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { CreateProcessJson } from '../types';

export const useCreateProcess = () =>
  useMutation((process: CreateProcessJson) =>
    processesRepo.createProcess(process),
  );
